import { CHANGE_ADULT_COUNT, CHANGE_CHILDREN_COUNT } from '../../../actions/filters';
import { TReduxActions } from '../../../types/redux';
import { defaultState } from './defaultState';
import { IGuests } from '../../../types/filters';

export function guestsReducer(state: IGuests = defaultState, action: TReduxActions): IGuests {
  switch (action.type) {
    case CHANGE_ADULT_COUNT: {
      return {
        ...state,
        adults: action.payload,
      };
    }

    case CHANGE_CHILDREN_COUNT: {
      return {
        ...state,
        children: action.payload,
      };
    }

    default:
      return state;
  }
}
